// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.adviceClass[data-v-fd6ab1f2]{\r\n    max-height: 120px !important;\r\n    overflow-y: auto !important;\n}\n.el-form-item[data-v-fd6ab1f2] {\r\n    border-bottom: 2px solid #eee;\n}\n.footerClass[data-v-fd6ab1f2]{\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\n}\r\n", ""]);
// Exports
module.exports = exports;
